<template>
  <div class="create-organisation">
    <button class="btn btn-ss-standout"
            type="button"
            @click="$modal.show(`create-organisation-modal`)">
      + Organisation
    </button>

    <vjs-modal name="create-organisation-modal" title="Create New Organisation" icon="la la-plus-circle">
      <template slot="body-content">
        <form class="kt-form kt-form--fit kt-form--label-align-right kt-form--group-seperator-dashed">
          <div class="form-group kt-form__group row">
            <div class="col-12 col-md-6 mt-3">
              <label>FreshSales Account</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <multiselect v-model="selected_sales_account" :options="sales_accounts"
                             label="name"
                             track-by="id"
                             :allow-empty="false"
                             :allow-mutiple="false"
                             :close-on-select="true"
                             placeholder="Select FreshSales Account" />
                <button type="button" class="btn btn-ss-link p-0 m-0 d-inline align-baseline" @click.prevent="getSalesAccounts(true)">
                  Refresh
                </button>
              </div>
            </div>
            <div class="col-12 col-md-6  mt-3">
              <div v-if="selected_sales_account">
                <label>FreshSales Data</label>
                <table class="table table-striped">
                  <tbody>
                    <tr>
                      <td>ID</td>
                      <td>{{ selected_sales_account.id }}</td>
                    </tr>
                    <tr>
                      <td>Company Name</td>
                      <td>{{ selected_sales_account.name }}</td>
                    </tr>

                    <tr>
                      <td colspan="2">
                        <a :href="`https://sharpstream.freshsales.io/accounts/${selected_sales_account.id}`" target="_blank" class="btn btn-sm btn-ss">View in FreshSales</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-if="selected_sales_account" class="col-12 col-md-6">
              <label>Name <em>*</em></label>
              <div class="input-group kt-input-group kt-input-group--square">
                <input v-model="name"
                       v-validate="'required'"
                       name="name" type="text"
                       :class="{'form-control': true }"
                       class="kt-input" placeholder=""
                       autocomplete="off">
              </div>
              <transition name="fade">
                <p v-show="errors.has('name')" class="help is-danger">
                  {{ errors.first('name') }}
                </p>
              </transition>
            </div>
          </div>
        </form>
      </template>

      <template slot="body-controls">
        <button type="button" class="btn btn-ss-standout" @click="saveOrganisation">
          Save Organisation
        </button>
        <button type="button" class="btn btn-ss-cancel" @click="closeModal">
          Cancel
        </button>
      </template>
    </vjs-modal>
  </div>
</template>

<script>
import VjsModal from "VueModals/VjsModal";
export default {
  components: { VjsModal },
  data() {
    return {
      name: null,
      sales_accounts: [],
      selected_sales_account: null,
    };
  },
  mounted() {
    this.getSalesAccounts();
  },
  methods: {
    getSalesAccounts(fresh = false) {
      axios.get('/api/v1/admin/fresh-sales/unused-sales-accounts', {
        params: { fresh: fresh },
      }).then((response) => {
        this.sales_accounts = response.data.data;
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
    saveOrganisation() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          axios.post(`/api/v1/admin/organisation`, {
            name: this.name,
            provider_id: this.selected_sales_account.id,
          }).then((response) => {
            toastr.success("Organisation Created.");
            $('#create-organisation-modal .close').click();
            this.name = null;
            EventBus.$emit('organisation-added', response.data.data);
            this.closeModal();
          }).catch((error) => {
            window.handleAxiosError(error);
          });
        } else {
          toastr.error('Some fields have not been completed correctly');
        }
      });
    },
    closeModal() {
      this.$modal.hide(`create-organisation-modal`);
    },
  },
};
</script>
